// libraries
import classNames from "classnames";
import { useCallback, useState } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { requestOtp } from "../../../../setup/api/services/otp";
import { IRegisterByPhoneResponseData } from "../../../../setup/api/services/user/models";
import { ROUTES } from "../../../../setup/constants";
import {
  IF_NOT_RECEIVED_OTP,
  RESEND,
  TIMER_VALUE_10,
  TIMER_VALUE_30,
  TIMER_VALUE_60,
  TIMER_VALUE_300,
} from "../../signup/constants";
import Timer from "../../signup/verticalStepper/timer";
// styles
import styles from "./formHeading.module.scss";
interface Props extends React.HTMLProps<HTMLDivElement> {
  header: string;
  subHeader: string;
  showReset: boolean;
  showTimer?: boolean;
  registeredUser?: IRegisterByPhoneResponseData;
  type?: string;
}

export const FormHeading: React.FC<Props> = ({
  header,
  subHeader,
  showReset = false,
  showTimer = false,
  registeredUser = undefined,
  type = "",
  children,
}: Props): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [timer, setTimer] = useState<number>(TIMER_VALUE_10);
  const [numberOfOtp, setNumberOfOtp] = useState<number>(0);

  const [resendOtp, setResendOtp] = useState<boolean>(false);

  const displayResendOtp = useCallback(() => {
    setResendOtp(true);
    setNumberOfOtp(numberOfOtp + 1);
    console.log("number of otps", numberOfOtp);
    if (numberOfOtp === 0) {
      setTimer(TIMER_VALUE_30);
    } else if (numberOfOtp === 1) {
      setTimer(TIMER_VALUE_60);
    } else {
      setTimer(TIMER_VALUE_300);
    }
  }, [numberOfOtp]);

  const requestPhoneOtp = useCallback(async (id: string | undefined) => {
    if (id) {
      await requestOtp(id).catch((e) => console.error(e));
      setResendOtp(false);
    }
  }, []);

  return (
    <div className={styles["container"]}>
      <h1 className="g900">{header}</h1>
      <div className={styles.subtitleContainer}>
        <p className={classNames("subtitle1", "subtitle", "g700")}>
          {subHeader}
          <p
            onClick={() => {
              type === "pin"
                ? navigate(ROUTES.RESET)
                : window.location.reload();
            }}
            className={classNames("subtitle1", styles["link"])}
            style={{ display: showReset ? "inline-flex" : "none" }}>
            {type === "pin"
              ? t("lbl_did_you_forget_pincode")
              : t("lbl_edit_mobile_number")}
          </p>
        </p>
      </div>
      {children}
      {showTimer && (
        <p className={styles.extra_step}>
          {resendOtp ? (
            <div
              className={styles.mobile_link}
              onClick={() => {
                registeredUser && requestPhoneOtp(registeredUser?.id);
              }}>
              {IF_NOT_RECEIVED_OTP}
              <p className={styles.link}>{RESEND}</p>
            </div>
          ) : (
            <Timer timerValue={timer} callBack={displayResendOtp}>
              {IF_NOT_RECEIVED_OTP}
            </Timer>
          )}
        </p>
      )}
    </div>
  );
};

export default FormHeading;
